import { useCallback } from 'react';
import { useAuth } from '@/providers/SupabaseAuthProvider';

type LogoutHookInterface = () => void;

const useLogout = (): LogoutHookInterface => {
  const { signOut } = useAuth();

  const logout = useCallback((): void => {
    localStorage.clear();
    signOut();
  }, [signOut]);

  return logout;
};

export default useLogout;
